import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSingleSided = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 322,
	height: 175,
	viewBox: "0 0 322 175",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 322,
			height: 175,
			rx: 8,
			fill: "#F2F2F2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 22.5,
			y: 21.5,
			width: 23.3118,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 22.5,
			y: 100.871,
			width: 23.3118,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 92.5753,
			y: 21.5,
			width: 23.3118,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 92.5753,
			y: 100.871,
			width: 23.3118,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 162.651,
			y: 21.5,
			width: 23.3118,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 162.651,
			y: 100.871,
			width: 23.3118,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 232.726,
			y: 21.5,
			width: 23.3118,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 232.726,
			y: 100.871,
			width: 23.3118,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 46.0968,
			y: 21.5,
			width: 22.5968,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 46.0968,
			y: 100.871,
			width: 22.5968,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 116.172,
			y: 21.5,
			width: 22.5968,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 116.172,
			y: 100.871,
			width: 22.5968,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 186.247,
			y: 21.5,
			width: 22.5968,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 186.247,
			y: 100.871,
			width: 22.5968,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 256.323,
			y: 21.5,
			width: 22.5968,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 256.323,
			y: 100.871,
			width: 22.5968,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 68.9785,
			y: 21.5,
			width: 23.3118,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 68.9785,
			y: 100.871,
			width: 23.3118,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 139.054,
			y: 21.5,
			width: 23.3118,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 139.054,
			y: 100.871,
			width: 23.3118,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 209.129,
			y: 21.5,
			width: 23.3118,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 209.129,
			y: 100.871,
			width: 23.3118,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 279.204,
			y: 21.5,
			width: 23.3118,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 279.204,
			y: 100.871,
			width: 23.3118,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.3575 100.371H303.016",
			stroke: "#0FC417",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.5806 48.172L45.9543 74.629L57.7527 48.172",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.5806 126.47L45.9543 100.013L57.7527 126.47",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.7742 48.172L92.4328 73.914L104.946 48.172",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.7742 126.47L92.4328 100.728L104.946 126.47",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.253 48.172L138.911 73.914L151.425 48.172",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.253 126.47L138.911 100.728L151.425 126.47",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.446 48.172L186.105 73.914L198.618 48.172",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.446 126.47L186.105 100.728L198.618 126.47",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M217.925 48.172L232.583 73.914L245.097 48.172",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M217.925 126.47L232.583 100.728L245.097 126.47",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M264.403 48.172L279.062 73.914L291.575 48.172",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M264.403 126.47L279.062 100.728L291.575 126.47",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.1331 74.629V99.6559",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M139.09 74.629L139.09 100.371",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M232.762 74.629L232.762 100.371",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M91.8965 74.629V99.6559",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M185.569 74.629V99.6559",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M278.526 74.629V100.371",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.5968 100.728H92.4328",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M138.554 100.728H185.39",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M232.226 100.728H279.062",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_247_413)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M93.8 97C93.952 97 94.0836 97.0934 94.1524 97.2358L95.9287 100.747C95.9771 100.818 96.0008 100.908 96.0008 101.001C96.0008 101.094 95.9771 101.183 95.9287 101.255L94.1524 104.766C94.1184 104.838 94.0684 104.897 94.0064 104.939C93.9444 104.98 93.8731 105.002 93.8009 105.002H90.2C90.048 105.002 89.9164 104.908 89.8476 104.766L88.0722 101.254C88.0238 101.183 88 101.093 88 101C88 100.907 88.0238 100.818 88.0722 100.746L89.8484 97.2358C89.9164 97.0934 90.0488 97 90.2008 97H93.8009H93.8Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M95.3513 100.82L93.8433 97.8387C93.7856 97.7179 93.6735 97.6387 93.5445 97.6387H90.4878C90.3587 97.6387 90.2466 97.7179 90.1889 97.8387L88.6809 100.82C88.6402 100.88 88.6198 100.956 88.6198 101.035C88.6198 101.114 88.6402 101.19 88.6809 101.25L90.1889 104.231C90.2466 104.352 90.3587 104.431 90.4878 104.431H93.5445C93.6056 104.431 93.6667 104.413 93.7194 104.377C93.772 104.342 93.8153 104.292 93.8433 104.231L95.3513 101.25C95.392 101.19 95.4124 101.114 95.4124 101.035C95.4124 100.956 95.392 100.88 95.3513 100.82ZM90.588 98.2047H91.9338L91.3504 99.333L89.8 102.33L89.1488 101.045L90.588 98.2047ZM93.4443 103.886H90.588L89.9563 102.64H94.0751L93.4434 103.886H93.4443ZM94.2322 102.33L92.0976 98.2047H93.4434L94.8826 101.045L94.2314 102.33H94.2322Z",
				fill: "#E1373B"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_247_413)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M187.8 97C187.952 97 188.084 97.0934 188.152 97.2358L189.929 100.747C189.977 100.818 190.001 100.908 190.001 101.001C190.001 101.094 189.977 101.183 189.929 101.255L188.152 104.766C188.118 104.838 188.068 104.897 188.006 104.939C187.944 104.98 187.873 105.002 187.801 105.002H184.2C184.048 105.002 183.916 104.908 183.848 104.766L182.072 101.254C182.024 101.183 182 101.093 182 101C182 100.907 182.024 100.818 182.072 100.746L183.848 97.2358C183.916 97.0934 184.049 97 184.201 97H187.801H187.8Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M189.351 100.82L187.843 97.8387C187.786 97.7179 187.674 97.6387 187.544 97.6387H184.488C184.359 97.6387 184.247 97.7179 184.189 97.8387L182.681 100.82C182.64 100.88 182.62 100.956 182.62 101.035C182.62 101.114 182.64 101.19 182.681 101.25L184.189 104.231C184.247 104.352 184.359 104.431 184.488 104.431H187.544C187.606 104.431 187.667 104.413 187.719 104.377C187.772 104.342 187.815 104.292 187.843 104.231L189.351 101.25C189.392 101.19 189.412 101.114 189.412 101.035C189.412 100.956 189.392 100.88 189.351 100.82ZM184.588 98.2047H185.934L185.35 99.333L183.8 102.33L183.149 101.045L184.588 98.2047ZM187.444 103.886H184.588L183.956 102.64H188.075L187.443 103.886H187.444ZM188.232 102.33L186.098 98.2047H187.443L188.883 101.045L188.231 102.33H188.232Z",
				fill: "#E1373B"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip2_247_413)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M280.8 97C280.952 97 281.084 97.0934 281.152 97.2358L282.929 100.747C282.977 100.818 283.001 100.908 283.001 101.001C283.001 101.094 282.977 101.183 282.929 101.255L281.152 104.766C281.118 104.838 281.068 104.897 281.006 104.939C280.944 104.98 280.873 105.002 280.801 105.002H277.2C277.048 105.002 276.916 104.908 276.848 104.766L275.072 101.254C275.024 101.183 275 101.093 275 101C275 100.907 275.024 100.818 275.072 100.746L276.848 97.2358C276.916 97.0934 277.049 97 277.201 97H280.801H280.8Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M282.351 100.82L280.843 97.8387C280.786 97.7179 280.674 97.6387 280.545 97.6387H277.488C277.359 97.6387 277.247 97.7179 277.189 97.8387L275.681 100.82C275.64 100.88 275.62 100.956 275.62 101.035C275.62 101.114 275.64 101.19 275.681 101.25L277.189 104.231C277.247 104.352 277.359 104.431 277.488 104.431H280.545C280.606 104.431 280.667 104.413 280.719 104.377C280.772 104.342 280.815 104.292 280.843 104.231L282.351 101.25C282.392 101.19 282.412 101.114 282.412 101.035C282.412 100.956 282.392 100.88 282.351 100.82ZM277.588 98.2047H278.934L278.351 99.333L276.8 102.33L276.149 101.045L277.588 98.2047ZM280.444 103.886H277.588L276.956 102.64H281.075L280.443 103.886H280.444ZM281.232 102.33L279.098 98.2047H280.443L281.883 101.045L281.231 102.33H281.232Z",
				fill: "#E1373B"
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_247_413",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 8,
					height: 8,
					fill: "white",
					transform: "translate(88 97)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip1_247_413",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 8,
					height: 8,
					fill: "white",
					transform: "translate(182 97)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip2_247_413",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 8,
					height: 8,
					fill: "white",
					transform: "translate(275 97)"
				})
			})
		] })
	]
});
export default SvgSingleSided;
